export default "__VITE_ASSET__22fc5c7d__"